import React from 'react'
import styled from 'styled-components'
import MobilePhoneNumberForm from '../../components/standalone/MobilePhoneNumberForm'
import { Container } from '../../components/landing/display'
import ButtonLink from '../../components/display/ButtonLink'
import useReduxSelector from '../../hooks/useReduxSelector'

const Title = styled.h2`
  font-size: 40px;
  font-weight: 400;
  color: ${({ theme }) => theme['-ds-core-300'].value};
`

const Wrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
  font-size: 20px;
  font-weight: 300;
  line-height: 150%;
  color: ${({ theme }) => theme['-ds-neutral-700'].value};
`

type Props = { phoneNumberVerified: boolean }
export const StorytellerOnboardingDisplay = ({
  phoneNumberVerified,
}: Props) => {
  return (
    <>
      <Container>
        <Wrapper>
          <Title>Verify your phone number</Title>
          <p>
            Please verify your phone number, so we can send you updates about
            upcoming Story Assignments.
          </p>
          <MobilePhoneNumberForm />
          {phoneNumberVerified && (
            <ButtonLink href="/my/assignment-availability?invitation=true">
              Continue
            </ButtonLink>
          )}
        </Wrapper>
      </Container>
    </>
  )
}

const StorytellerOnboarding = () => {
  const currentUser = useReduxSelector((reduxState) => {
    return reduxState.auth.currentUser
  })

  if (!currentUser) {
    return null
  }

  return (
    <StorytellerOnboardingDisplay
      phoneNumberVerified={currentUser.phone_number_verified}
    />
  )
}

export default StorytellerOnboarding
